import { forwardRef } from "react";
import { renderTypography, useTypography, useTypographyStyles, } from "./styles";
export const Span = forwardRef((props, ref) => {
    const state = useTypography(props, ref);
    useTypographyStyles(state);
    return renderTypography(state);
});
Span.displayName = "Span";
export default Span;
